<template>
  <div class="border rounded mt-2 mx-2">
    <div class="d-flex align-items-center mx-2 mt-2"
      :class="{ 'mb-2': isShowDetail }"
    >
      <img
        class="mx-2 avatar"
        :src="avatar"
        @error="() => (isFail = true)"
      />
      <div class="flex-grow-1 mt-1">
        <div class="d-flex align-items-center justify-content-between">
          <div class="d-inline-flex align-items-center">
            <span class="fw-medium text-black d-inline-flex align-items-center"
              >{{ conversation.customer.name }}
              <img
                class="mx-2 icon"
                :src="conversationIcon"
              />
            </span>
            <span class="grey--text"
              >•
              {{ moment(new Date(conversation.last_message_time )).format(
                  'HH:mm DD/MM/YYYY'
                ) }}
              </span>
          </div>
          <div class="d-flex align-items-center gap-1">
            <el-button 
              :icon="isShowDetail ? 'icon-arrow1-up' : 'icon-arrow1-down'" 
              circle plain
              style="font-size: 28px; border: none; box-shadow: none;padding: 0;" 
              @click.stop="toggleDetail"
            >
            </el-button>
            <el-tooltip class="item" effect="dark" content="Nhắn tin qua Salework Chat" placement="top-start">
              <a
                :href="'https://chat.salework.net/conversations?channel=' + conversation._id.channel + '&conversation_id=' + conversation._id.conversation_id + '&customer_id=' + conversation._id.customer_id"
                target="_blank"
                style="text-decoration: none;"
              >
                <el-button 
                  icon="el-icon-chat-line-round"
                  circle plain
                  style="font-size: 20px; border: none; box-shadow: none;padding: 0;" 
                >
                </el-button>
              </a>
            </el-tooltip>
          </div>
        </div>
        <div
          v-if="!isShowDetail"
          class="grey--text mb-2"
          @click.stop="() => {}"
        >
          {{
              conversation._id.account_id === conversation.last_message_from_id
                  ? 'Bạn: '
                  : ''
          }}{{ conversation.last_message_content }}
        </div>
      </div>
    </div>
    <iframe
      @click.stop="() => {}"
      v-if="isShowDetail"
      class="framePreview"
      :src="conversationDetailUrl"
      id="iframeChat"
      width="100%"
      height="650"
    ></iframe>

    <div class="line"></div>
    <div class="my-2 px-2">
      Nhân viên tư vấn:
      <span class="text-primary">{{ conversation.pic.user }}</span>
    </div>
  </div>
</template>

<script>
import shopeeIcon from '@/assets/icons/shopee-icon.png';
import lazadaIcon from '@/assets/icons/lazada-icon.png';
import facebookIcon from '@/assets/icons/facebook-icon.png';
import instagramIcon from '@/assets/icons/instagram-icon.png';
import zaloOAIcon from '@/assets/icons/zalo-oa-icon.png';
import otherIcon from '@/assets/icons/other.png';
import { HTTP } from '@/lib/http-common';

  export default {
    data(){
      return{
        isShowDetail : false,
        isFail : false,
      }
    },
    props : {
      conversation : {
        type : Object,
        require : true
      },
    },
    computed : {
      avatar() {
        return this.conversation.customer.avatar && !this.isFail
          ? this.conversation.customer.avatar
          : otherIcon;
      },
      conversationIcon() {
        switch (this.conversation._id.channel) {
          case 'Facebook':
            return facebookIcon;
          case 'Instagram':
            return instagramIcon;
          case 'ZaloOA':
            return zaloOAIcon;
          case 'Lazada':
            return lazadaIcon;
          case 'Shopee':
            return shopeeIcon;
          default:
            return facebookIcon;
        }
      },
      accountSwName() {
        const account = this.accountList.find(
          (item) => item.accountId === this.conversation.accountId
        );
        return account ? (account.swName ? account.swName : account.zaloName) : '';
      },
      conversationDetailUrl() {
        const id = this.conversation._id;
        return `https://chat.salework.net/iframe?conversation_id=${id.conversation_id}&account_id=${id.account_id}&channel=${id.channel}&customer_id=${id.customer_id}`;
      }
    },
    methods : {
    toggleDetail() {
      this.isShowDetail = !this.isShowDetail;
      this.saveLog(this.isShowDetail ? "OPEN" : "CLOSE");
    },
    async saveLog(action) {
      try {
        await HTTP.post("/api/log-chat/save-log-chat", {
          action: action,
          conversation: this.conversation._id.conversation_id,
          type: "CHAT",
          sessionId: this.app.sessionId,
          displayName: this.conversation.customer.name,
          phone: this.conversation.customer.phone || "",
          channel: this.conversation._id.channel
        });
      } catch (e) {
        console.error("Lỗi lưu log:", e);
      }
    },
    handleBeforeUnload() {
      this.saveLog("CLOSE");
    },
  },
  mounted() {
    window.addEventListener("beforeunload", this.handleBeforeUnload);
  },
  beforeDestroy() {
    this.saveLog("CLOSE");
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
  }
  }
</script>
  
<style scoped>
.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: contain;
}
.line{
  height: 1px;
  background-color: #EAECF2;
}
.framePreview {
    margin-bottom: -5px;
    border-top: thin solid #d3d7de;
}
.icon{
  width: 24px;
  height: 24px;
  border-radius: 50%;
  object-fit: contain;
}
</style>